import * as React from 'react';

import type {SelectSize} from 'shells/select-picker-generic/select-picker-generic-creatable';
import type {Option} from 'shells/select-picker-generic/types';

import {GraphQLSelect} from './graphql-select';
import {useGetCompetitors} from './hooks/use-get-competitors';

type Props = {
    onChange: (option: Option) => void;
    selectedId: string | null | undefined;
    isCreateable?: boolean;
    size?: SelectSize;
    hideDivider?: boolean;
    placeholder?: string;
    onCreateOption?: (option: string) => void;
};

export function GraphQLSelectCompetitors(props: Props) {
    const {competitors, isLoading, refetch} = useGetCompetitors();

    const competitorsOptions = competitors
        ? competitors.map((competitor) => ({
              label: competitor.name,
              value: competitor.id,
          }))
        : [];

    return (
        <GraphQLSelect
            isLoading={isLoading}
            placeholder={props.placeholder || 'Search competitors…'}
            models={competitorsOptions}
            labelKey='label'
            valueKey='value'
            onChange={props.onChange}
            selectedId={props.selectedId}
            refetch={refetch}
            isCreateable={props.isCreateable}
            size={props.size}
            hideDivider={props.hideDivider}
            onCreateOption={props.onCreateOption}
            menuZIndex={11}
        />
    );
}
